// imports
import Component from 'minsky-kit/js/components/Component';

// private statics
const VERSION = '1.0.0';

// class definition
export default class CalendarHover extends Component {
    // constructor
    constructor (args = {}, objectName = 'CalendarHover') {
        args.debug = args.debug || false;
        // super
        super(args, objectName);

        this.groups = this.$el.querySelectorAll('.calendar__group');

        // listeners
        this.groups.forEach((g) => {
            g.querySelectorAll('.calendar-item__main').forEach((item) => {
                const image = item.querySelector('.calendar-item__image');
                let newImage = null;
                if (image) {
                    newImage = image.cloneNode(true);
                    g.appendChild(newImage);
                    item.removeChild(image);
                }

                item.addEventListener('mouseover', () => {
                    if (!g.classList.contains('calendar__group--hover')) {
                        g.classList.add('calendar__group--hover');
                    }

                    if (newImage) {
                        if (!newImage.classList.contains('calendar-item__image--hover')) {
                            newImage.classList.add('calendar-item__image--hover');
                        }
                    }
                });

                item.addEventListener('mouseout', () => {
                    if (g.classList.contains('calendar__group--hover')) {
                        g.classList.remove('calendar__group--hover');
                    }

                    if (newImage) {
                        if (newImage.classList.contains('calendar-item__image--hover')) {
                            newImage.classList.remove('calendar-item__image--hover');
                        }
                    }
                });
            });
        });
    }

    destroy () {
        // super destroy
        super.destroy();
    }

    show () {
        this.triggers[0].classList.add('active');
        super.show();
    }

    hide () {
        // console.log(this);
        this.triggers[0].classList.remove('active');
        super.hide();
    }

    // getters & setters
    static get version () { return VERSION; }
}
